// Abu Dhabi - AC gas refill. Focus: inland heat, villa outdoor units, leak-first approach.
const content = {
    slug: 'ac-gas-refill',
    title: (c) => `AC Gas Refill Abu Dhabi from ${c.money(c.tables.gas.R410A.half)} | Leak Check First`,
    description: (c) =>
        `AC gas refill in Abu Dhabi: R410A top-up ${c.money(c.tables.gas.R410A.half)}, R32 ${c.money(c.tables.gas.R32.half)} per outdoor unit, after a pressure and leak check.`,
    eyebrow: 'Abu Dhabi · Gas refill',
    h1: 'AC Gas Refill in Abu Dhabi',
    lead: (c) =>
        `If your villa's upstairs units can't keep up by mid-afternoon, low refrigerant is one possibility. We measure the pressure, look for the leak, and refill at a fixed price per outdoor unit - from ${c.money(c.tables.gas.R410A.half)} for an R410A top-up.`,
    image: 'blog/living/air-conditioner-condenser-cleaning.jpg',
    imageAlt: 'Outdoor AC condenser being checked before a gas refill',
    facts: ['Pressure and leak check', 'Per outdoor unit', 'R410A, R32, R22'],
    priceTitle: 'Gas refill prices',
    priceIntro: 'Prices are per outdoor unit (compressor). Choose "Not sure" in your notes if you can\'t read the label - the technician confirms before charging.',
    panel: { type: 'gas' },
    sections: [
        {
            title: 'Signs of low gas in Abu Dhabi homes',
            items: [
                'The unit cools in the morning but loses the battle by 2 pm, even after cleaning.',
                'Frost or ice on the thick copper pipe at the outdoor unit.',
                'The outdoor unit runs without a break and feels hot to stand next to.',
                'A hissing or bubbling sound near the indoor unit pipes.',
            ],
        },
        {
            title: 'Why we check before we refill',
            tone: 'muted',
            paragraphs: [
                'Gas does not get used up. If a unit is low, it is leaking - commonly at flare joints on villa units that have been moved during renovation, or at corroded outdoor coils in homes close to the sea on Saadiyat and the Corniche.',
                'A refill without a repair buys a few weeks or months. We would rather tell you where the leak is and what fixing it costs, so you can decide whether to repair, refill, or - for old R22 units - replace.',
            ],
        },
    ],
    faqs: [
        {
            question: 'What does an AC gas refill cost in Abu Dhabi?',
            answer: (c) => `${c.money(c.tables.gas.R410A.half)} for an R410A top-up and ${c.money(c.tables.gas.R32.half)} for R32, per outdoor unit. A full refill after a leak repair costs ${c.money(c.tables.gas.R410A.full)} for R410A.`,
        },
        {
            question: 'My building is on district cooling - can I refill gas?',
            answer: 'No. District-cooled apartments, common in island towers, use chilled water rather than refrigerant. Book a cleaning or repair diagnosis instead.',
        },
        {
            question: 'How long does a refill take?',
            answer: 'About an hour per outdoor unit including the pressure and leak check. A leak repair adds time and is quoted separately.',
        },
    ],
    schema: {
        name: 'AC Gas Refill in Abu Dhabi',
        serviceType: 'Air conditioner refrigerant recharge',
        offers: (c) => [
            { name: 'R410A top-up, 1 outdoor unit', price: c.tables.gas.R410A.half },
            { name: 'R32 top-up, 1 outdoor unit', price: c.tables.gas.R32.half },
            { name: 'R410A full refill, 1 outdoor unit', price: c.tables.gas.R410A.full },
        ],
    },
}

export default content
